import { getRouter } from '@/router/index';
import ArticleHandler from '@/application-pages/Article/ArticleHandler.vue';

function getPageProps(page) {
    const pageProps = window.__dyanmic_template_props__[page];

    if (!pageProps) {
        return {};
    }

    return pageProps;
}

let homepageArticleLayoutType = null;
let homePageProps = getPageProps('CategoryPage');
const compadoHost = window['__host__'];

if (
    window['__host__']['ghost_writer_articles'] &&
    compadoHost['gw_article_content']
) {
    homepageArticleLayoutType = 'ArticleBasedLayout';
    homePageProps = getPageProps(homepageArticleLayoutType);
    const type = compadoHost['gw_article_content']['type'];

    if (['top5_home', 'top5_category_home'].includes(type)) {
        const categoryId =
            compadoHost['gw_article_content']['category_id'] || null;

        window.__host__.category_tree_ids['/'] = categoryId;

        homepageArticleLayoutType = 'ArticleHandler';
        homePageProps = {
            slug: compadoHost['gw_article_content']['slug'],
            useCategoryEndpoint:
                compadoHost['is_default_language'] && Boolean(categoryId),
        };
    }

    if (!compadoHost['is_default_language']) {
        homePageProps = {
            ...homePageProps,
            isNonDefaultLanguage: true,
        };
    }
}

let routes = [];

const languagePath = window['__language_path__'];
const defaultRoute = window['__default_path__'];

// inject dynamic routes
if (window.__host__['category_tree']) {
    for (let i = 0; i < window.__host__['category_tree'].length; i++) {
        const path = languagePath + window.__host__['category_tree'][i];
        routes.push({
            path,
            component: ArticleHandler,
            name: path,
            props: {
                useCategoryEndpoint: true,
            },
        });
    }

    for (let i = 0; i < window.__host__['category_tree'].length; i++) {
        const path = languagePath + window.__host__['category_tree'][i];
        routes.push({
            path: path + '/:article',
            component: ArticleHandler,
            name: path + '_article',
        });
    }
}

routes = routes.concat([
    {
        path: languagePath + '/report-content',
        component: () =>
            import('@/application-pages/ReportContent/ReportContent'),
        name: 'reportContent',
    },
    {
        path: languagePath + '/faq',
        component: () =>
            import('@/application-pages/SecondaryPage/SecondaryPage.vue'),
        name: 'faq',
    },
    {
        path: languagePath + '/about-us',
        component: () =>
            import('@/application-pages/SecondaryPage/SecondaryPage.vue'),
        name: 'aboutus',
    },
    {
        path: languagePath + '/sitemap',
        component: () => import('@/application-pages/Sitemap/SiteMap.vue'),
        name: 'sitemap',
    },
    {
        path: languagePath + '/privacy',
        component: () =>
            import('@/application-pages/SecondaryPage/SecondaryPage.vue'),
        name: 'privacy',
    },
    {
        path: languagePath + '/imprint',
        component: () =>
            import('@/application-pages/SecondaryPage/SecondaryPage.vue'),
        name: 'imprint',
    },
    {
        path: languagePath + '/authors/:author',
        component: () =>
            import('@/application-pages/AuthorPage/AuthorPage.vue'),
        name: 'author',
    },
    {
        path: languagePath + '/',
        props: homePageProps,
        // component: ArticleHandler,
        component: () => import('@/application-pages/AdsenseHome.vue'),
        name: 'home',
    },
    {
        path: '*',
        beforeEnter: (to, from, next) => {
            next(defaultRoute);
        },
    },
]);

export const router = getRouter(routes);
